import { useTypedParams } from '@sorare/routing';

import { Rarity } from '@sorare/core/src/__generated__/globalTypes';

import { Wheel } from '@sorare/marketplace/src/components/Wheel';

import { PageParams } from './__generated__/routeParams';

const MarketWheelRarityPage = () => {
  const { rarity } = useTypedParams<PageParams>();
  return <Wheel rarity={rarity as Rarity} />;
};
export default MarketWheelRarityPage;
